import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ForgotPasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: ${props => props.theme.background};
`;

export const ForgotPasswordBox = styled.div`
  width: 450px;
  max-width: 90%;
  padding: 40px;
  background-color: ${props => props.theme.forgotPasswordBoxBackground || props.theme.background};
  border-radius: 8px;
`;

export const ForgotPasswordTitle = styled.h1`
  font-size: 24px;
  text-align: center;
  color: ${props => props.theme.text};
  margin-bottom: 20px;
`;

export const ForgotPasswordDescription = styled.p`
  font-size: 14px;
  text-align: center;
  color: ${props => props.theme.textSecondary};
  margin-bottom: 30px;
`;

export const ForgotPasswordForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const EmailInput = styled.input`
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.borderLight};
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  background-color: ${({ theme }) => theme.background};
  color: ${props => props.theme.text};
  transition: border-color 0.2s;
  margin-bottom: 20px;

  &:focus {
    border-color: ${({ theme }) => theme.primaryAccent};
  }

  &::placeholder {
    color: ${props => props.theme.placeholderColor};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const SendButton = styled.button`
  flex: 1;
  padding: 12px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.border};
    cursor: not-allowed;
  }
`;

export const CancelButton = styled.button`
  flex: 1;
  padding: 12px;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.primaryAccent};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.background};
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: ${props => props.theme.error};
  background-color: ${props => props.theme.errorBackground};
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;

export const SuccessMessage = styled.div`
  color: ${props => props.theme.success};
  background-color: ${props => props.theme.successBackground};
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  white-space: pre-line;
`;

export const BackToLoginLink = styled(Link)`
  display: block;
  margin-top: 15px;
  text-align: center;
  color: ${props => props.theme.text};
  font-size: 14px;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.primaryAccent};
  }
`;

export const ResendLink = styled.button`
  background: none;
  border: none;
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
  width: 100%;
  color: ${props => props.theme.textSecondary};
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.primaryAccent};
  }
`;

export const AlertModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const AlertModalContent = styled.div`
  background-color: ${({theme}) => theme.deleteModalBackground};
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.deleteModalBorder};
  padding: 24px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  
  h3 {
    color: ${({theme}) => theme.success};
    margin-bottom: 16px;
  }
  
  p {
    margin-bottom: 24px;
    line-height: 1.5;
  }
`;

export const AlertModalButtons = styled.div`
  display: flex;
  justify-content: center;
`;

export const OkButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
`; 